import { datadogLogs } from '@datadog/browser-logs';
import appSettings from '../settings';
let isInitialized = false;
export const initializeDatadogLogs = (): void => {
  if (typeof window === 'undefined') return;
  if (isInitialized) return;
  const clientToken = process.env.NEXT_PUBLIC_DD_CLIENT_TOKEN;
  if (!clientToken) return;
  datadogLogs.init({
    clientToken,
    site: 'datadoghq.com',
    service: 'categories-next-ui-browser',
    env: process.env.NODE_ENV === 'production' ? 'prod' : 'dev',
    version: appSettings.appVersion,
    sessionSampleRate: 100,
    forwardErrorsToLogs: false
  });
  isInitialized = true;
};